<template>
    <nav role="navigation" class="main-nav">
        <!--
        <router-link v-if="!isManager" to="/" class="nav-link">
          Dashboard
        </router-link>
        <router-link v-if="!isManager" to="/spaardoelen" class="nav-link">
          Spaardoelen
        </router-link>
        -->
        <router-link to="/settings" class="nav-link">Instellingen</router-link>
        <router-link v-if="isManager" to="/admin" class="nav-link"
            >Admin</router-link
        >
    </nav>
</template>
<script>
export default {
    name: 'RockMainNav',
    data() {
        return {
            isManager: false
        };
    },
    mounted() {
        this.isManager = this.$keycloak.hasUserRole('manager');
    }
};
</script>
